export default "__VITE_ASSET__DXYR9cMd__"